import styled from 'styled-components';

import { theme } from '../GlobalStyles';

const SC = {};

SC.CategoryWrapper = styled.div`
  display: ${(props) => (props.type === 'mobile' ? 'flex' : 'none')};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 3rem;
  overflow: hidden;
  font-size: 1.125rem;
  width: 100%;
  height: 100%;
  background-color: #f0ebf2;
  border-radius: 2rem;
  padding: 0;
  margin: 0 0 1.875rem;
  &[data-open='true'] {
    border-radius: 1rem;
    background-color: transparent;
    border: 1px solid ${theme.colors.purple};
    .slider {
      padding: 0 0 1rem;
    }
  }
  .slider {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    justify-content: left;
    transition: all 250ms linear;
    -ms-overflow-style: none; /* hide scrollbar in IE and Edge */
    scrollbar-width: none; /* hide scrollbar in Firefox */
    position: relative;
    .btn-toggle {
      position: absolute;
      background: transparent;
      border: none;
      width: 3.75rem;
      padding: 0;
      right: 0;
      display: block;
      cursor: pointer;
      align-self: flex-start;
      align-items: flex-start;
      transform: rotate(90deg);
      svg {
        width: 2.625rem;
        height: 2.625rem;
      }
      &[data-open='true'] {
        transform: rotate(-90deg);
      }
      ${theme.mediaQueries.above.xlarge} {
        display: none;
      }
    }
    .btn-slide,
    .btn-slide svg {
      width: 3rem;
      height: 3rem;
    }
    .btn-slide {
      position: absolute;
      background: transparent;
      border: none;
      align-self: center;
      justify-content: center;
      display: none;
      cursor: pointer;
      &.prev {
        left: 0.5%;
        display: none;
        ${theme.mediaQueries.above.xlarge} {
          display: block;
          transform: rotate(180deg);
        }
      }
      &.next {
        right: 0.5%;
        align-self: flex-start;
        align-items: flex-start;
        transform: rotate(45deg);
        ${theme.mediaQueries.above.xlarge} {
          display: block;
          align-self: center;
          align-items: center;
          transform: rotate(0deg);
        }
      }
      &.next.open {
        transform: rotate(-90deg);
      }
      ${theme.mediaQueries.above.xlarge} {
        display: flex;
      }
    }
    ${theme.mediaQueries.above.xlarge} {
      justify-content: center;
    }
  }

  ${theme.mediaQueries.above.xlarge} {
    flex-direction: column;
    display: ${(props) => (props.type === 'mobile' ? 'none' : 'flex')};

    &[data-open='true'] {
      border: none;
      border-radius: 2rem;
      background-color: #f0ebf2;
      .slider {
        padding: 0;
      }
    }
  }
`;

SC.StyledCategory = styled.div`
  width: 100%;
  padding: 0.5rem 2rem;
  cursor: pointer;
  text-align: left;
  display: none;
  &[data-active='true'] {
    display: flex;
    border: none;
    font-weight: 500;
    color: ${theme.colors.purple};
  }
  &[data-first='true'] {
    border-bottom: 1px solid purple;
    margin-bottom: 1rem;
  }

  &[data-open='true'] {
    display: flex;
  }
  ${theme.mediaQueries.above.xlarge} {
    width: 15.25rem;
    border-radius: 1.5rem;
    display: flex;
    text-align: center;
    justify-content: center;
    color: ${theme.colors.purple};
    &[data-active='true'] {
      background: ${theme.colors.purple};
      color: white;
    }
    &[data-first='true'] {
      border-bottom: none;
      margin-bottom: 0;
    }
  }
`;

const filterElements = {
  ...SC,
  theme,
};

export default filterElements;
